/* cl-mc (maison-corval): camada de UI propria do clone (Focal 12.7 dele -> Shrine).
   1. trilhos .cl-swipe (nota do operador: grades com toque no mobile): pontos clicaveis + arraste de mouse
   2. colecao: "Trier par" (popover) -> ?sort_by= nativo; filtros (Disponibilite/Prix) -> ?filter.v.* nativos;
      botao "Filtres" do mobile abre a gaveta de filtros
   3. popover generico do Focal (cl-*-popover): abre/fecha pelo botao aria-controls */
(function () {
  'use strict';
  function dots(tr) {
    var n = tr.children.length; if (n < 2 || tr.__clDots) return; tr.__clDots = true;
    var d = document.createElement('div'); d.className = 'cl-swipe-dots';
    for (var i = 0; i < n; i++) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Aller a ' + (i + 1)); d.appendChild(b); }
    tr.parentNode.insertBefore(d, tr.nextSibling);
    function sync() {
      var w = tr.children[0].getBoundingClientRect().width || 1, k = Math.round(tr.scrollLeft / w);
      Array.prototype.forEach.call(d.children, function (b, j) { b.classList.toggle('is-on', j === k); });
    }
    d.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var k = Array.prototype.indexOf.call(d.children, b);
      tr.scrollTo({ left: tr.children[k].offsetLeft - tr.children[0].offsetLeft, behavior: 'smooth' });
    });
    tr.addEventListener('scroll', sync, { passive: true }); sync();
  }

  /* colecao */
  function go(mut) { var u = new URL(location.href); mut(u.searchParams); u.searchParams.delete('page'); location.href = u.toString(); }
  document.addEventListener('change', function (e) {
    var r = e.target.closest('[class*="cl-sec-"] input[name="sort_by"][type="radio"]');
    if (r) { go(function (p) { p.set('sort_by', r.value); }); return; }
    var f = e.target.closest('[class*="cl-sec-"] #facet-filters-form');
    if (f && e.target.name && e.target.name.indexOf('filter.') === 0) {
      var fd = new FormData(f);
      go(function (p) {
        Array.from(p.keys()).filter(function (k) { return k.indexOf('filter.') === 0; }).forEach(function (k) { p.delete(k); });
        fd.forEach(function (v, k) { if (k.indexOf('filter.') === 0 && v !== '') p.append(k, v); });
      });
    }
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[class*="cl-sec-"] [aria-controls="facet-filters"]');
    var ff = document.getElementById('facet-filters');
    if (t && ff) { e.preventDefault(); ff.setAttribute('open', ''); ff.classList.add('cl-open'); document.documentElement.classList.add('cl-lock'); return; }
    if (ff && e.target.closest('#facet-filters [data-action="close"], #facet-filters .drawer__overlay')) {
      ff.removeAttribute('open'); ff.classList.remove('cl-open'); document.documentElement.classList.remove('cl-lock');
    }
    /* popover generico */
    var btn = e.target.closest('[class*="cl-sec-"] button[aria-controls], .cl-pdp-host button[aria-controls]');
    var pop = btn && document.getElementById(btn.getAttribute('aria-controls'));
    if (pop && /^CL-([A-Z-]*POPOVER|COMBO-BOX)$/.test(pop.tagName)) {
      e.preventDefault();
      var willOpen = !pop.hasAttribute('open');
      if (willOpen) pop.setAttribute('open', ''); else pop.removeAttribute('open');
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }
    var cl = e.target.closest('[class*="cl-sec-"] [data-action="close"], [class*="cl-sec-"] .popover__overlay, .cl-pdp-host .combo-box [data-action="close"], .cl-pdp-host .combo-box__overlay');
    var host = cl && cl.closest('[open]');
    document.querySelectorAll('[class*="cl-sec-"] [open], .cl-pdp-host [open]').forEach(function (p) {
      if (!/^CL-([A-Z-]*POPOVER|COMBO-BOX)$/.test(p.tagName)) return;
      if (p === host || !p.contains(e.target)) { p.removeAttribute('open');
        var ob = document.querySelector('[aria-controls="' + p.id + '"]'); if (ob) ob.setAttribute('aria-expanded', 'false'); }
    });
  });

  /* 4. PDP: barra fixa de compra (cl-product-sticky-form) aparece quando o botao principal sai da tela;
        o combo de variante dela escolhe o swatch do buybox (mesmo value = id da opcao do Focal) */
  function pdp(host) {
    if (host.__clMc) return; host.__clMc = true;
    var sticky = host.querySelector('.product-sticky-form');
    var main = host.querySelector('form[id^="product-form-main"] button[type="submit"]');
    if (sticky && main && 'IntersectionObserver' in window) {
      sticky.setAttribute('hidden', '');
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          var past = !x.isIntersecting && x.boundingClientRect.top < 0;
          if (past) sticky.removeAttribute('hidden'); else sticky.setAttribute('hidden', '');
        });
      }).observe(main);
    }
    host.addEventListener('click', function (e) {
      var opt = e.target.closest('.combo-box__option-item[value]');
      if (!opt) return;
      e.preventDefault();
      var box = opt.closest('.combo-box');
      var r = host.querySelector('input[type="radio"][data-option-position][value="' + opt.getAttribute('value') + '"]');
      if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      box.querySelectorAll('.combo-box__option-item').forEach(function (o) { o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); });
      var tb = host.querySelector('[aria-controls="' + box.id + '"] .select__selected-value');
      if (tb) tb.innerHTML = opt.innerHTML;
      box.removeAttribute('open');
      var b = host.querySelector('[aria-controls="' + box.id + '"]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  /* 5. zoom da galeria (lupa do Focal; o PhotoSwipe dele nao existe aqui): lightbox com a foto atual + setas */
  function zoom(host) {
    var items = [].slice.call(host.querySelectorAll('.product__media-item:not(.is-filtered) img, .clx-product__media-item:not(.is-filtered) img'));
    if (!items.length) return;
    var cur = Math.max(0, items.findIndex(function (im) { return im.closest('.is-selected'); }));
    var big = function (im) { var ss = (im.getAttribute('srcset') || '').split(',').map(function (x) { return x.trim().split(' ')[0]; }).filter(Boolean); return ss[ss.length - 1] || im.currentSrc || im.src; };
    var ov = document.createElement('div'); ov.className = 'cl-zoom'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true');
    ov.innerHTML = '<button type="button" class="cl-zoom__close" aria-label="Fermer">&times;</button><button type="button" class="cl-zoom__nav cl-zoom__prev" aria-label="Precedent">&#8249;</button><img alt=""><button type="button" class="cl-zoom__nav cl-zoom__next" aria-label="Suivant">&#8250;</button>';
    var img = ov.querySelector('img');
    function show(i) { cur = (i + items.length) % items.length; img.src = big(items[cur]); img.alt = items[cur].alt || ''; }
    function close() { ov.remove(); document.documentElement.classList.remove('cl-lock'); document.removeEventListener('keydown', key); }
    function key(e) { if (e.key === 'Escape') close(); if (e.key === 'ArrowRight') show(cur + 1); if (e.key === 'ArrowLeft') show(cur - 1); }
    ov.addEventListener('click', function (e) {
      if (e.target.closest('.cl-zoom__prev')) return show(cur - 1);
      if (e.target.closest('.cl-zoom__next')) return show(cur + 1);
      if (e.target === img) return;
      close();
    });
    var x0 = null;
    ov.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    ov.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); x0 = null; });
    document.addEventListener('keydown', key);
    document.body.appendChild(ov); document.documentElement.classList.add('cl-lock'); show(cur);
  }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('.cl-pdp-host .product__zoom-button');
    if (z) { e.preventDefault(); e.stopPropagation(); zoom(z.closest('.cl-pdp-host')); }
  }, true);


  /* 6. trilho de produtos do Focal (cl-product-list > .product-list__inner--scroller + cl-prev-next-buttons):
        setas rolam uma "pagina" de cards; habilita/desabilita nas pontas */
  function rail(pl) {
    if (pl.__clRail) return; pl.__clRail = true;
    var inner = pl.querySelector('.product-list__inner--scroller'); if (!inner) return;
    var tr = inner.scrollWidth > inner.clientWidth + 2 ? inner : (inner.closest('.scroller') || inner);
    var prev = pl.querySelector('.prev-next-button--prev'), next = pl.querySelector('.prev-next-button--next');
    function sync() {
      var max = tr.scrollWidth - tr.clientWidth - 2;
      if (prev) prev.disabled = tr.scrollLeft <= 2;
      if (next) next.disabled = tr.scrollLeft >= max;
    }
    function step(dir) {
      var card = tr.querySelector('cl-product-item, .product-item');
      var w = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(tr).columnGap || 0 || 24) : tr.clientWidth / 2;
      var per = Math.max(1, Math.floor((tr.clientWidth + 1) / w));
      tr.scrollBy({ left: dir * per * w, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); step(1); });
    tr.addEventListener('scroll', sync, { passive: true }); sync();
  }


  /* 7. "Acheter avec Shop" / "Plus de moyens de paiement": adiciona o item do buybox e vai direto ao checkout */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.cl-pdp-host [data-cl-buynow]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var host = b.closest('.cl-pdp-host');
    var f = [].slice.call(host.querySelectorAll('form[action="/cart/add"]')).filter(function (x) { return /product-form-main/.test(x.getAttribute('id') || ''); })[0];
    if (!f) { location.href = '/checkout'; return; }
    var items = typeof f.__clItems === 'function' ? f.__clItems() : null, body, hdr = { 'Accept': 'application/json' };
    if (items && items.length) { body = JSON.stringify({ items: items }); hdr['Content-Type'] = 'application/json'; }
    else { body = new FormData(f); var q = host.querySelector('input[name="quantity"][form="' + f.getAttribute('id') + '"], form[id="' + f.getAttribute('id') + '"] input[name="quantity"]'); body.set('quantity', (q && q.value) || '1'); }
    b.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: hdr, body: body }).then(function (r) { if (!r.ok) throw r; location.href = '/checkout'; })
      .catch(function () { b.removeAttribute('aria-busy'); alert("Ce produit n'a pas pu etre ajoute."); });
  }, true);


  /* 8. modais dos blocos do buybox ("EN SAVOIR PLUS" do upsell, player dos videos de clientes): presos no
        contexto de empilhamento da secao ficavam ATRAS do header fixo -> portal no <body> dentro de um invólucro
        com as MESMAS classes do wrapper cl-sec-* (display:contents), para o CSS escopado continuar casando */
  function portal(modal) {
    if (!modal || modal.__clPortal) return; modal.__clPortal = true;
    var chain = [], el = modal.parentElement;
    while (el && el !== document.body) { if (/\bcl-sec-|\bcl-pdp-host\b/.test(el.className || '')) chain.unshift(el.className); el = el.parentElement; }
    var host = document.body;
    chain.forEach(function (cls) { var d = document.createElement('div'); d.className = cls + ' cl-portal'; d.style.display = 'contents'; host.appendChild(d); host = d; });
    host.appendChild(modal);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-upsell-modal-open]');
    if (t) portal(document.querySelector('[data-upsell-modal="' + t.getAttribute('data-upsell-modal-open') + '"]'));
    var v = e.target.closest('[data-cv-trigger]');
    if (v) { var root = v.closest('.customer-videos'); portal(root && root.querySelector('[data-cv-modal]')); }
  }, true);

  function boot() { document.querySelectorAll('.cl-swipe').forEach(dots); document.querySelectorAll('.cl-pdp-host').forEach(pdp); document.querySelectorAll('[class*="cl-sec-"] cl-product-list').forEach(rail); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
